import {Container,Sprite,Texture,Rectangle} from 'pixi.js';
import type {AssetSpriteView} from '../houses/AssetSprite';
import {characterImage} from './characterImages';
import {CHARACTER_CATALOG as catalog,characterKey,type CharacterAppearance} from './characterAppearance';
import {AVATAR_BODY_HEIGHT} from './avatarAppearance';
import type {CityAsset} from '../api/types';

export const CUSTOM_CHARACTER_ASSET:CityAsset={assetId:catalog.assetId,anchorX:.5,anchorY:85/96,spriteSheet:{frameWidth:80,frameHeight:96,columns:13,rows:8},avatarAnimation:{directions:8,walkFrames:12,fps:15,bodyHeight:72}};
type Atlas={bitmap:ImageBitmap;texture:Texture;references:number};
const atlases=new Map<string,Promise<Atlas>>();
function release(key:string,atlas:Atlas):void{
 atlas.references--;if(atlas.references)return;
 atlases.delete(key);atlas.texture.destroy(true);atlas.bitmap.close();
}
export async function customCharacterSprites(appearance:CharacterAppearance):Promise<{walk:AssetSpriteView;sit:AssetSpriteView;dispose:()=>void}>{
 const key=characterKey(appearance);
 let promise=atlases.get(key);
 if(!promise){promise=characterImage(appearance).then(bitmap=>({bitmap,texture:Texture.from(bitmap),references:0}));atlases.set(key,promise);promise.catch(()=>{if(atlases.get(key)===promise)atlases.delete(key);});}
 const atlas=await promise;atlas.references++;
 const views:AssetSpriteView[]=[];
 for(const [start,count]of [[0,13],[13,9]]){
  const frames:Texture[]=[];
  for(let row=0;row<8;row++)for(let column=0;column<count;column++)frames.push(new Texture({source:atlas.texture.source,frame:new Rectangle((start+column)*80,row*96,80,96)}));
  const view=new Container() as AssetSpriteView;const sprite=new Sprite(frames[0]);sprite.anchor.set(.5,85/96);view.addChild(sprite);
  view.__assetSprite=sprite;view.__frameTextures=frames;view.scale.set(AVATAR_BODY_HEIGHT/catalog.bodyHeight);
  view.once('destroyed',()=>{for(const frame of frames)frame.destroy(false);});views.push(view);
 }
 views[1].visible=false;let disposed=false;
 return {walk:views[0],sit:views[1],dispose:()=>{if(disposed)return;disposed=true;release(key,atlas);}};
}

/** The route-only resident layer needs walking frames and owns their lifetime. */
export async function createCharacterSprite(appearance:CharacterAppearance):Promise<AssetSpriteView>{
 const views=await customCharacterSprites(appearance);
 views.walk.once('destroyed',()=>{views.sit.destroy({children:true});views.dispose();});
 return views.walk;
}
